import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TableColumnOptions } from '@brunsker/libs/core/ui/table/src';
import { NewApiProductService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api';
import { Filial } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/models/product.models';
import { MapperService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'brunsker-show-estoque-filiais',
  templateUrl: './show-estoque-filiais.component.html',
  styleUrls: ['./show-estoque-filiais.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowEstoqueFiliaisComponent implements OnInit {
  columnsOptions: TableColumnOptions[] =
    this.mapperService.createFiliaisColumnOptions();
  dataDisplay!: Observable<Filial[]>;
  hasPagination = { staticPagination: false };

  constructor(
    private readonly mapperService: MapperService,
    private readonly newApiProductService: NewApiProductService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      productId: number;
    }
  ) {}

  ngOnInit(): void {
    this.dataDisplay = this.newApiProductService
      .getProductInAllBranches({
        prod: this.data.productId,
      })
      .pipe(
        map((branches) => {
          const MAP_DISPLAY_COLUMNS = branches.map((branch) => {
            return {
              id: branch.id_filial,
              endereco: branch.endereco,
              estoque: branch.qtdisponivel,
              preco: branch.preco,
            } as Filial;
          });
          return MAP_DISPLAY_COLUMNS;
        })
      );
  }
}
